const SchoolDetails = ({ details }) => {
  const LoadingView = () => {
    return (
      <div className="col-span-2 flex items-center justify-center gap-5 my-4">
        <div className="w-24 h-24 bg-gray-400 rounded-full animate-pulse" />
        <div className="flex flex-col gap-2">
          <div className="w-60 h-8 bg-gray-400 rounded-lg animate-pulse" />
          <div className="w-60 h-4 bg-gray-400 rounded-lg animate-pulse" />
          <div className="w-24 h-4 bg-gray-400 rounded-lg animate-pulse" />
        </div>
      </div>
    );
  };
  const SchoolDetailsView = () => {
    return (
      <div className="col-span-2 flex items-center justify-center gap-5 my-4">
        <div className="w-20 h-20 bg-gray-400 overflow-hidden flex items-center justify-center rounded-full">
          {details?.schoolLogoUrl ? (
            <img
              src={details?.schoolLogoUrl}
              alt="schoolLogo"
              className="h-full w-full"
            />
          ) : (
            <div className="w-full h-full bg-gray-600 flex items-center justify-center">
              <span className="text-5xl font-bold text-white capitalize">
                {details?.schoolName[0]}
              </span>
            </div>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <h2 className="text-2xl font-semibold">{details?.schoolName}</h2>
          <p className="text-base">
            {details?.schoolAddress.address}, {details?.schoolAddress.city},{" "}
            {details?.schoolAddress.state}, {details?.schoolAddress.country},{" "}
            {details?.schoolAddress.pin}
          </p>
        </div>
      </div>
    );
  };

  return details ? <SchoolDetailsView /> : <LoadingView />;
};

export default SchoolDetails;
